"use client";
import { CSSRuntime } from '@master/css-runtime';
import React, { createContext, useContext, useRef } from 'react';
import useIsomorphicLayoutEffect from './uses/useIsomorphicLayoutEffect.mjs';
import { useUpdateEffect } from './uses/useUpdateEffect.mjs';

const CSSRuntimeContext = /*#__PURE__*/ createContext(undefined);
const useCSSRuntime = ()=>useContext(CSSRuntimeContext);
function CSSRuntimeProvider(props) {
    const cssRuntime = useRef(undefined);
    /** onMounted */ useIsomorphicLayoutEffect(()=>{
        cssRuntime.current = new CSSRuntime(props.root ?? document, props.config).observe();
        return ()=>{
            cssRuntime.current?.destroy();
            cssRuntime.current = undefined;
        };
    }, []);
    /** on config change */ useUpdateEffect(()=>{
        if (cssRuntime.current) {
            cssRuntime.current.refresh(props.config);
        }
    }, [
        props.config
    ]);
    /** on root change */ useUpdateEffect(()=>{
        if (cssRuntime.current) {
            cssRuntime.current.destroy();
            cssRuntime.current = undefined;
            cssRuntime.current = new CSSRuntime(props.root ?? document, props.config).observe();
        }
    }, [
        props.root
    ]);
    return /*#__PURE__*/ React.createElement(CSSRuntimeContext.Provider, {
        value: cssRuntime.current
    }, props.children);
}

export { CSSRuntimeContext, CSSRuntimeProvider as default, useCSSRuntime };
